import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  d: "M3.1 12 13.3 1.8c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0 0 0 0 0 0 0L2.1 11.7c-.2.2-.2.5 0 .7l10.5 10.5c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L3.1 12z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  d: "M21.9 1.1c-.2-.2-.5-.2-.7 0L10.7 11.7c-.2.2-.2.5 0 .7l10.5 10.5c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L11.7 12 21.9 1.8c.2-.2.2-.5 0-.7 0 0 0 0 0 0z"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  d: "M13 23c-.1 0-.2 0-.3-.1L2.1 12.3c-.2-.2-.2-.5 0-.7L12.6 1.1c.2-.2.5-.2.7 0 .2.2.2.5 0 .7 0 0 0 0 0 0L3.1 12l10.2 10.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"
}, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-width": "1.5",
  "stroke-miterlimit": "10",
  d: "M21.6 23c-.1 0-.2 0-.3-.1L10.7 12.3c-.2-.2-.2-.5 0-.7L21.2 1.1c.2-.2.5-.2.7 0 .2.2.2.5 0 .7 0 0 0 0 0 0L11.7 12l10.2 10.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"
}, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }